module.exports = __webpack_public_path__ + "static/media/army.e08d7455.png";